(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .controller('sgProjectTeamCtrl', sgProjectTeamController);

  sgProjectTeamController.$inject = ['$scope', 'Auth', 'Project', 'errorMessageService', 'ProjectDataservice',
    'Constants', 'Labels', '$injector'];

  function sgProjectTeamController ($scope, Auth, ProjectAPI, errorMessageService, ProjectDataservice,
    Constants, Labels, $injector) {

    $scope.LABELS = Labels;
    $scope.type = $scope.project ? 'new' : 'edit';
    $scope.project = $scope.project || $scope.model.project;
    $scope.users = $scope.users || $scope.model.users;
    $scope.projectRoles = Constants.getList('PROJECT_ROLES');
    $scope.userRoles = Constants.getList('USER_ROLES');

    /**
     * User select
     * */
    $scope.updateUsers = function (str) {
      return $scope.users.filter(function (user) {
        const some = $scope.project.users.some(function (selectedUser) {
          return selectedUser.userId._id === user._id;
        });
        return !some && user.fullName.toLowerCase().indexOf(str) > -1;
      });
    };

    setTimeout(() => {
      $scope.sg2AuthService = $injector.get('sg2AuthService');
    }, 100);

    function editUsersAPICall (users, successMsg) {
      const data = {
        project: {
          users,
        },
        _id: $scope.project._id,
        versionId: $scope.project.versionId,
      };
      ProjectAPI.editProject(data).$promise
        .then((updatedProj) => {
          $scope.project = updatedProj;
          errorMessageService.showSuccess(successMsg);
          ProjectDataservice.setProjectById(updatedProj._id, updatedProj);
        });
    }

    $scope.userSelected = function (user) {
      if (user) {
        const userObj = {
          active: true,
          deleted: false,
          projectRole: determineNewUserProjectRole(user),
          userId: user
        };
        if ($scope.type === 'new') {
          $scope.project.users.push(userObj);
        } else if ($scope.type === 'edit') {
          editUsersAPICall([...$scope.project.users, userObj],
            $scope.LABELS.getLabel('projectuseradded'));
        }
        $scope.userSearch = '';
        $scope.selectedUser = undefined;
      }
    };

    function determineNewUserProjectRole (user) {
      if ($scope.project.users.length === 0) {
        return 'manager';
      }
      if (user.role === 'guest') {
        return 'guest';
      } else if (user.role === 'admin') {
        return 'manager';
      }
      return 'contributor';
    }

    // Init with current user as project owner
    if ($scope.project.users.length === 0) {
      $scope.userSelected(Auth.getCurrentUser());
    }

    /**
     * User management
     * */

    $scope.openMemberMenu = function ($mdMenu, event) {
      $mdMenu.open(event);
    };

    $scope.disableRole = function (member, role) {
      const currentUser = Auth.getCurrentUser();
      if (currentUser._id === member.userId._id) {
        if (role !== 'manager') {
          return true;
        };
      }

      return member.projectRole === role;
    };

    $scope.toggleUserActivation = function (member) {
      if ($scope.type === 'new') {
        $scope.project.users = $scope.project.users.filter(function (user) {
          return user.userId._id !== member.userId._id;
        });
      } else if ($scope.type === 'edit') {
        member.active = !member.active;
        editUsersAPICall($scope.project.users,
          $scope.LABELS.getLabel('projectuserdeactivate'));
      }
    };

    $scope.changeProjectRole = function (member, newRole) {
      member.projectRole = newRole;
      if ($scope.type === 'edit') {
        editUsersAPICall($scope.project.users,
          $scope.LABELS.getLabel('userroleadjusted'));
      }
    };

    $scope.findProjectRoleValue = (role, key) => {
      const userRole = $scope.projectRoles.find((projRole) => projRole.value === role);
      return userRole[key];
    };

    $scope.getUserRoleDisplayName = (user) => {
      const role = $scope.userRoles.find((role) => role.value === user.role);
      return role && role.displayName ? role.displayName : '';
    };
  }
})();
